/**
 * @file 漏洞搜索
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_VUL_HOMEPAGE, GET_VUL_SEARCH, GET_VUL_DETAIL} from './ActionTypes';

export function fetchVulHomepagee(dispatch, obj) {
    return rcAjax('GET', '/xiapi/api/v1/vul/homepage', obj, {}, data => {
        dispatch({type: GET_VUL_HOMEPAGE, data: data.data});
    });
}

export function fetchVulSearch(dispatch, obj) {
    return rcAjax('POST', '/xiapi/api/v1/vul/search', {}, obj, data => {
        dispatch({type: GET_VUL_SEARCH, data: data.data});
    });
}

export function fetchVulDetail(dispatch, obj) {
    return rcAjax('POST', '/xiapi/api/v1/vul/detail', {}, obj, data => {
        dispatch({type: GET_VUL_DETAIL, data: data.data});
    });
}


// WEBPACK FOOTER //
// ./src/actions/bugSearchAction.js